import {
    getUserAuthProvidersFreshQuery,
    startTelegramLinkMutation,
    startWhatsappLinkMutation,
} from "../api/graphql/userAuthProvider";
import {checkNotificationBotMappingFreshQuery} from "../api/graphql/userNotificationPreference";

const POLL_INTERVAL_MS = 3000;
const POLL_TIMEOUT_MS = 3 * 60 * 1000;

const isLinked = (rows, provider) =>
    (rows || []).some(
        (item) =>
            item?.provider === provider && item?.isActive !== false && item?.unlinkedAt == null,
    );

const readStart = (payload) => {
    if (payload?.__typename === "BaseError" || !payload?.url) {
        return {url: null, errKey: payload?.errKey || "admin.err.system_error"};
    }

    return {url: payload.url, errKey: null};
};

// one place builds the deep link, so the bot and the token never drift apart
export const buildTelegramLinkUrl = async (twoFactorChallengeId = null) => {
    const response = await startTelegramLinkMutation(twoFactorChallengeId);

    return readStart(response?.startTelegramLink);
};

// the client messages us rather than the other way round, so the number we end up
// trusting is the one their message arrives from
export const buildWhatsappLinkUrl = async (twoFactorChallengeId = null) => {
    const response = await startWhatsappLinkMutation(twoFactorChallengeId);

    return readStart(response?.startWhatsappLink);
};

// the tap happens in another app, so the only way back is to watch for the change
const poll = (check, onDone) => {
    const startedAt = Date.now();

    const timer = setInterval(async () => {
        if (Date.now() - startedAt > POLL_TIMEOUT_MS) {
            clearInterval(timer);
            return;
        }

        try {
            if (await check()) {
                clearInterval(timer);
                onDone();
            }
        } catch (error) {
            // a failed poll is not a failed link, so keep watching until the timeout
        }
    }, POLL_INTERVAL_MS);

    return () => clearInterval(timer);
};

const waitForProviderLink = (provider, onLinked) =>
    poll(async () => {
        const response = await getUserAuthProvidersFreshQuery();
        return isLinked(response?.getUserAuthProviders?.data, provider);
    }, onLinked);

export const waitForTelegramLink = (onLinked) => waitForProviderLink("telegram", onLinked);

export const waitForWhatsappLink = (onLinked) => waitForProviderLink("whatsapp", onLinked);

export const waitForNotificationBot = (userId, onMapped) =>
    poll(async () => {
        const response = await checkNotificationBotMappingFreshQuery(userId);
        return !!response?.checkNotificationBotMapping;
    }, onMapped);
